var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.6006 4.56365C10.3071 4.56365 9.91838 4.55715 9.43439 4.55715C8.25406 4.55715 7.28348 3.5802 7.28348 2.38875V0.29835C7.28348 0.1339 7.15224 0 6.98935 0H3.55126C1.94676 0 0.649902 1.3169 0.649902 2.93085V9.9346C0.649902 11.6278 2.00855 13 3.68513 13H8.805C10.4037 13 11.6999 11.6916 11.6999 10.0763V4.85615C11.6999 4.69105 11.5693 4.5578 11.4058 4.55845C11.131 4.5604 10.8014 4.56365 10.6006 4.56365Z",
    fill: "#8A837C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4e0d63ca2cc27372b84ba5a1f97afa0f.svg";
export { ForwardRef as ReactComponent };